export class ErrorState {
    action: string;//page and method information
    error: any;
}